// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s4wM","content":"styles_content__og3o1"};